module.exports = __webpack_public_path__ + "img/hr-branch-particle-shadow-02.7f2be637.png";